import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPipelineStandsInputDto, PipelineStandCreateDto, PipelineStandDto, PipelineStandExcelDownloadDto, PipelineStandUpdateDto } from '../dtos/pipeline-stand/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PipelineStandService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: PipelineStandCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelineStandDto>({
      method: 'POST',
      url: '/api/operational/pipelineStands',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/pipelineStands/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/pipelineStands',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelineStandDto>({
      method: 'GET',
      url: `/api/operational/pipelineStands/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/pipelineStands/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPipelineStandsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PipelineStandDto>>({
      method: 'GET',
      url: '/api/operational/pipelineStands',
      params: { pipelinePropertyId: input.pipelinePropertyId, pipelinePropertyName: input.pipelinePropertyName, name: input.name, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, standReasonId: input.standReasonId, negotiationReasonId: input.negotiationReasonId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PipelineStandExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/pipelineStands/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, pipelinePropertyId: input.pipelinePropertyId, pipelinePropertyName: input.pipelinePropertyName, name: input.name, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, standReasonId: input.standReasonId, negotiationReasonId: input.negotiationReasonId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelineStandDto[]>({
      method: 'GET',
      url: '/api/operational/pipelineStands/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PipelineStandUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PipelineStandDto>({
      method: 'PUT',
      url: `/api/operational/pipelineStands/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}